module.exports = __webpack_public_path__ + "static/media/logo.39fc32a6.png";